// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Zipwi","closedButton":"umDzC","icon":"ETF9J","iconHide":"qAqW4","desktopIcon":"OfqVq"};